<template>
    <div
        class="relative flex flex-col justify-center items-center py-6 lg:py-12 my-4 lg:my-12 mx-4 lg:mx-24 xl:mx-64 bg-[#eef4ff] rounded-[12px] lg:rounded-[30px]">
        <h3 class="text-base lg:text-2xl text-gray-800 leading-[25px] lg:leading-[44px] font-semibold px-4">
            中小非标机械厂，选择轻熵科技 ERP&MES 一体化管理系统，交期&库存管理无烦恼
        </h3>
        <div class="mt-4 lg:mt-10 flex justify-center gap-x-6">
            <a class="contact-me inline-flex justify-center items-center p-0 mt-3 rounded-[16px] lg:rounded-[24px] w-[130px] h-[36px] lg:w-[170px] lg:h-[48px] bg-[#3e90ff] text-white hover:text-white text-sm lg:text-lg"
                href="/apply" target="_blank">
                联系我们
                <a-icon class="contact-icon ml-[18px]" type="arrow-right" />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homePageToContact',
}
</script>
<style scoped>
.contact-me {
    box-shadow: 0 14px 37px #66a0ff;
    font-weight: 500;
    will-change: transform;
    transition: transform .32s ease, box-shadow .32s ease;
}

.contact-me:hover {
    box-shadow: 0 2px 30px rgba(0, 0, 0, .1), 0 5px 10px rgba(0, 0, 0, .05);
    transform: translateY(-4px);
    color: #fff;
}

.contact-icon {
    animation: btnArrowEffect 3s both infinite;
}

@keyframes btnArrowEffect {
    0% {
        transform: translate(0)
    }

    10% {
        transform: translate(4px)
    }

    20% {
        transform: translate(-2px)
    }

    30% {
        transform: translate(4px)
    }

    40% {
        transform: translate(-2px)
    }

    50% {
        transform: translate(0)
    }
}
</style>
